<template>
  <div
    :dependentComputedProps="{
      isSessionPresent,
    }"
  >
    <div class="order-status-wrap pl16 mb24" v-if="visibleActiveOrders?.length">
      <observer
        :keepConnectedOnIntersection="true"
        :emitNotIntersecting="true"
        :options="{ root: null, threshold: 0.1, rootMargin: '0%' }"
        @intersect="cardObserved"
        @notIntersecting="cardUnobserved"
      />
      <div class="with-pagination">
        <Carousel
          :pauseAutoplayOnHover="true"
          :transition="500"
          :touchDrag="false"
          :mouseDrag="false"
          :settings="settings"
          :breakpoints="breakpoints"
        >
          <Slide
            class="dt-banner-wrap full-width-card"
            v-for="(item, index) in visibleActiveOrders"
            :key="item?.id"
          >
            <div
              :style="{
                background: item?.attributes?.backgroundGradient,
                width: clientPlatform === 'Web' ? '1100px' : '100vw',
              }"
            >
              <active-order-card
                :data-results="item"
                :activateOrderCardClick="true"
                :index="index"
                :data-props="modulePropsData"
                :key="item?.id"
              />
            </div>
          </Slide>
        </Carousel>
      </div>
    </div>
    <active-order-bottom-widget
      v-if="showBottomWidget && clientPlatform !== 'Web'"
      :data-props="modulePropsData"
      :data-results="getObservedOrderDetail"
    />
  </div>
</template>

<script>
import { keyMapsAction, keyMapsGetter } from "../helpers/storeKeys";
import { Carousel, Slide, Pagination } from "vue3-carousel";
import { clientPlatform } from "../config/apiEndpoints";
import ActiveOrderCard from "./ActiveOrderCard.vue";
import ActiveOrderBottomWidget from "./ActiveOrderBottomWidget.vue";
import Observer from "./Observer.vue";

export default {
  name: "NgTrackOrder",
  components: {
    Carousel,
    Slide,
    Pagination,
    ActiveOrderCard,
    ActiveOrderBottomWidget,
    Observer,
  },
  props: ["moduleProps"],
  data() {
    return {
      clientPlatform,
      sessionDependedMethodsProcessed: false,
      showBottomWidget: false,
      settings: {
        itemsToShow: 1,
        autoplay: "1800",
        wrapAround: false,
      },
      modulePropsData: {},
      breakpoints: {
        300: {
          itemsToShow: 1,
          snapAlign: "start",
          autoplay: false,
          wrapAround: false,
        },
        700: {
          itemsToShow: 2,
          snapAlign: "start",
          autoplay: false,
          wrapAround: false,
        },
        1024: {
          itemsToShow: 2,
          snapAlign: "start",
          autoplay: false,
          wrapAround: false,
        },
      },
    };
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};

    if (this.isLoggedIn) {
      this.$store.dispatch(keyMapsAction.ACTIVE_ORDERS_API);
    }

    this.breakpoints = {
      300: {
        itemsToShow: this.modulePropsData?.itemsToShow,
        snapAlign: "start",
        autoplay: false,
        wrapAround: false,
      },
      700: {
        itemsToShow: this.modulePropsData?.itemsToShow,
        snapAlign: "start",
        autoplay: false,
        wrapAround: false,
      },
      1024: {
        itemsToShow: this.modulePropsData?.itemsToShow,
        snapAlign: "start",
        autoplay: false,
        wrapAround: true,
      },
    };
  },
  methods: {
    cardObserved() {
      this.showBottomWidget = false;
    },
    cardUnobserved() {
      this.showBottomWidget = true;
    },
  },
  computed: {
    activeOrders() {
      return this.$store.getters[keyMapsGetter.GET_VALID_ACTIVE_ORDERS];
    },
    visibleActiveOrders() {
      const npsFiredOrderIds = this.$store.state.OrderTracking.npsFiredOrderIds;
      return this.activeOrders.filter(
        (order) => !npsFiredOrderIds.includes(order.id),
      );
    },
    isLoggedIn() {
      return this.$store.state?.Auth?.isLoggedIn;
    },
    isSessionPresent() {
      let isSessionP = this.$store.state.Auth.isSessionPresent;
      if (isSessionP && !this.sessionDependedMethodsProcessed) {
        this.sessionDependedMethodsProcessed = true;
      }
      return isSessionP;
    },
    getObservedOrderDetail() {
      return this.$store.getters[keyMapsGetter.GET_CURRENT_TRACKED_ORDER];
    },
  },
};
</script>
